import { Button } from '../../../styles/GlobalComponents';
import { Link } from 'react-router-dom';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { Icon, IconApproveNFTSuccess } from '../../../styles/Icons';
import { P2 } from '../../../styles/FontStyles';
import { DASHBOARD } from '../../../routes/routes';

export const Step7 = () => {
  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='20'>
              <IconApproveNFTSuccess />
            </Icon>
          </Flexed>
        </Flexed>

        <P2 bold center mb='20'>
          Your withdrawal has been approved. Your Hub NFT transfer is being
          processed.
        </P2>

        <Flexed column center>
          <Link to={DASHBOARD}>
            <Button w='200px' negative onClick={() => {}}>
              Back to Dashboard
            </Button>
          </Link>
        </Flexed>
      </Box>
    </>
  );
};
